export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyC3NtNwqTpk0RPr2b5BRoU7_SEArM9QATw",
    authDomain: "paginatetris2.firebaseapp.com",
    databaseURL: "https://paginatetris2.firebaseio.com",
    projectId: "paginatetris2",
    storageBucket: "paginatetris2.appspot.com",
    messagingSenderId: "539614940092",
    appId: "1:539614940092:web:4e75f914e5fddeebe3b9b9"
  },
};